import {
    Alignment,
    HorizontalPadding,
    Link,
    TopPadding,
} from '@easeltv/client-sdk';

import { useAnalytics } from '../../../providers/AnalyticsProvider/AnalyticsProvider';
import DumbFooterLinksBlock from './FooterLinksBlock.dumb';
/* ---------------------------------- Types --------------------------------- */

/** @interface `FooterLinksBlockI`
 * #### Interface for the FooterLinksBlock's props object
 */
export type FooterLinksBlockI = {
    /** the array of links to be displayed */
    links: Link[];

    /** controls alignment links and links container inside the footer */
    alignment: Alignment;

    /** controls left and right spacing beside the list of links */
    horizontalPadding: HorizontalPadding;

    /** controls amount of space above the list of links */
    topPadding: TopPadding;
};

/* -------------------------------- Component ------------------------------- */

/**
 * FooterLinksBlock
 *
 * @param props FooterLinksBlockI
 * @returns JSX.Element
 */
const FooterLinksBlock = ({
    links,
    alignment,
    horizontalPadding,
    topPadding,
}: FooterLinksBlockI) => {
    const { pageObject } = useAnalytics();

    return (
        <DumbFooterLinksBlock
            links={links}
            alignment={alignment}
            horizontalPadding={horizontalPadding}
            topPadding={topPadding}
            pageObject={pageObject}
        />
    );
};

/* --------------------------------- Export --------------------------------- */

export default FooterLinksBlock;
